import axios from './axiosInstance';

export const fetchFolders = () => axios.get('/cloud/folders');
